import { Route } from '@angular/router';

import { authGuard } from '@oneComply/core/guards/auth.guard';
import { companyAdminGuard } from '@oneComply/core/guards/company-admin.guard';
import { loginEntryGuard } from '@oneComply/core/guards/login-entry.guard';

export const appRoutes: Route[] = [
  {
    path: 'auth/callback',
    loadComponent: () => import('./pages/auth-callback/auth-callback').then((m) => m.AuthCallback),
    data: { title: 'Autenticação | DenunciaNR1' },
  },
  {
    path: 'admin/logout',
    loadComponent: () => import('./pages/logout/logout').then((m) => m.Logout),
    data: { title: 'Logout | DenunciaNR1' },
  },
  {
    path: 'admin/login',
    canActivate: [loginEntryGuard],
    loadComponent: () => import('./pages/login-entry/login-entry').then((m) => m.LoginEntry),
    data: { title: 'Login | DenunciaNR1' },
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [loginEntryGuard],
    loadComponent: () => import('./pages/login-entry/login-entry').then((m) => m.LoginEntry),
    data: { title: 'Login | DenunciaNR1' },
  },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
        data: { title: 'Dashboard | DenunciaNR1' },
      },
      {
        path: 'reports/active',
        loadComponent: () =>
          import('./pages/active-reports/active-reports').then((m) => m.ActiveReports),
        data: { title: 'Denúncias em andamento | DenunciaNR1' },
      },
      {
        path: 'reports/active/:uuid',
        loadComponent: () =>
          import('./pages/active-reports/details/active-reports-details').then(
            (m) => m.ActiveReportsDetails
          ),
        data: { title: 'Detalhes da denúncia | DenunciaNR1' },
      },
      {
        path: 'reports/archived',
        loadComponent: () =>
          import('./pages/archived-reports/archived-reports').then((m) => m.ArchivedReports),
        data: { title: 'Denúncias arquivadas | DenunciaNR1' },
      },
      {
        path: 'reports/archived/:uuid',
        loadComponent: () =>
          import('./pages/archived-reports/details/archived-reports-details').then(
            (m) => m.ArchivedReportsDetails
          ),
        data: { title: 'Detalhes da denúncia armazenada | DenunciaNR1' },
      },
      {
        path: 'categories',
        redirectTo: 'categories/list',
        pathMatch: 'full',
      },
      {
        path: 'categories/list',
        loadComponent: () =>
          import('./pages/categories/list/categories-list').then((m) => m.CategoriesList),
        data: { title: 'Categorias | DenunciaNR1' },
      },
      {
        path: 'categories/create',
        loadComponent: () =>
          import('./pages/categories/create/categories-create').then((m) => m.CategoriesCreate),
        data: { title: 'Nova categoria | DenunciaNR1' },
      },
      {
        path: 'categories/edit/:id',
        loadComponent: () =>
          import('./pages/categories/edit/categories-edit').then((m) => m.CategoriesEdit),
        data: { title: 'Editar categoria | DenunciaNR1' },
      },
      {
        path: 'categories/details/:id',
        loadComponent: () =>
          import('./pages/categories/details/categories-details').then((m) => m.CategoriesDetails),
        data: { title: 'Detalhes da categoria | DenunciaNR1' },
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./pages/notifications/notifications').then((m) => m.Notifications),
        data: { title: 'Notificações | DenunciaNR1' },
      },
      {
        path: 'activity-logs',
        canActivate: [companyAdminGuard],
        loadComponent: () =>
          import('./pages/activity-logs/activity-logs').then((m) => m.ActivityLogs),
        data: { title: 'Auditoria | DenunciaNR1' },
      },
      {
        path: 'users',
        canActivate: [companyAdminGuard],
        loadComponent: () => import('./pages/users/users').then((m) => m.Users),
        data: { title: 'Usuários | DenunciaNR1' },
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile').then((m) => m.Profile),
        data: { title: 'Perfil | DenunciaNR1' },
      },
      {
        path: 'settings',
        canActivate: [companyAdminGuard],
        loadComponent: () => import('./pages/settings/settings').then((m) => m.Settings),
        data: { title: 'Configurações | DenunciaNR1' },
      },
      {
        path: 'access-denied',
        loadComponent: () =>
          import('./components/admin-forbidden/admin-forbidden').then((m) => m.AdminForbidden),
        data: { title: 'Acesso negado | DenunciaNR1' },
      },
      { path: '**', redirectTo: 'dashboard' },
    ],
  },
];

